import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../actions'
import assets from 'modules/assets'
import { Link } from 'react-router'
import Menu from './Menu'
import * as parse from 'modules/parse'

class Alert extends Component {
  constructor(props) {
    super(props)
    this.state = {
      alertIsMinimized: this.props.alertIsMinimized,
      alertIsHidden: false
    }
  }
  componentDidMount() {
    let { dispatch } = this.props
    let url = assets('alert.md')
    dispatch(actions.token.fetchAlert(url))
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      menuState: nextProps.menuState,
      alertIsMinimized: nextProps.alertIsMinimized,
      alertData: nextProps.alertData,
      alertIsHidden: nextProps.alertIsHidden
    })
  }
  render() {
    if (this.state && this.state.alertIsHidden) {
      return (<span></span>)
    }

    if (this.state && this.state.alertIsMinimized) {
      return <div className="alert"></div>
    }

    let p = parse, largeText
    if (this.state.alertData) {
      let d = this.state.alertData
      largeText = p.changeColor(d['large-text'], 'open', 'white')
    }

    return (
      <div className="alert fade-in app-body">
        <h1 className="alert-title">If you are a high school student, you can apply to be a Kohai! Find out more from our program brochure EN | FR | JP</h1>
      </div>
    )
  }
}
Alert.contextTypes = {
}
Alert.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    location: ownProps.location,
    menuState: state.token.menuState,
    alertData: state.token.alertData,
    alertIsHidden: state.token.alertIsHidden
  }
}

export default connect(mapStateToProps)(Alert)



// WEBPACK FOOTER //
// ./src/components/Utils/Alert.js